import {type FC, useEffect, useRef, useState} from 'react';

import styled from 'styled-components';

import type {WithDomStyleProp} from '../../utils/utility-types';
import type {Props, StyledProps} from './types';

import {useController} from './controller';
import {lettersBase, lettersWeb, web} from './styles';

const StyledAvatarPlaceholder = styled.div<StyledProps>`
  ${web}
`;

const StyledLetters = styled.span<{size: number}>`
  ${lettersBase}
  ${lettersWeb}
`;

const AvatarPlaceholder: FC<WithDomStyleProp<Props>> = props => {
  const [size, setSize] = useState(0);

  const {colors, letters} = useController(props);

  const ref = useRef<HTMLDivElement>(null);

  const [observer] = useState(
    () =>
      new ResizeObserver(([entry]) => {
        if (!entry) {
          return;
        }

        const {height} = entry.contentRect;

        setSize(height);
      }),
  );

  useEffect(() => {
    let element: Element;

    if (ref.current) {
      element = ref.current;
      observer.observe(ref.current);
    }

    return () => {
      observer.unobserve(element);
    };
  }, [observer]);

  return (
    <StyledAvatarPlaceholder
      {...props}
      data-test-id={props.testID}
      ref={ref}
      style={{
        background: `linear-gradient(45deg, ${colors[0]}, ${colors[1]})`,
      }}
    >
      {size ? <StyledLetters size={size}>{letters}</StyledLetters> : null}
    </StyledAvatarPlaceholder>
  );
};

export {AvatarPlaceholder};
